<template>
    <Dialog header="Set Default Company" v-model:visible="display" :breakpoints="{'960px': '75vw'}" :style="{width: '30vw'}" :modal="true">
        <p class="line-height-3 m-0">
            <AutoComplete placeholder="Search" id="dd" :dropdown="true" :multiple="false" v-model="selectedAutoValue" :suggestions="autoFilteredValue" @complete="searchCompany($event)" field="name" style="width:100%"/>
        </p>
        <template #footer>
            <Button v-if="selectedAutoValue" label="Unset / Clear" @click="setDefaultCompany(true)" icon="pi pi-trash" class="p-button-outlined p-button-danger"/>
            <Button label="Set" @click="setDefaultCompany(false)" icon="pi pi-check" class="p-button-outlined"/>
        </template>
    </Dialog>
    <button class="p-link layout-topbar-button" v-tooltip.bottom="defaultCompanyText+defaultCompanyName" @click="open">
        <i class="pi pi-building"></i>
        <span>Set Default Company</span>
    </button>
</template>
<script>
import ApiService from '../../service/api/ApiService';
import authStore from '../../core/services/authStore/authStore';

export default {
	data() {
			return {
                autoValue: null,
                selectedAutoValue: authStore.getters.defaultCompany.name ? authStore.getters.defaultCompany : null,
                autoFilteredValue: [],
				display:false,
                defaultCompanyName: authStore.getters.defaultCompany.name ? authStore.getters.defaultCompany.name :'Not set',
                defaultCompanyText: "Set Default Company, Current Default : "
			}
		},
    created() {
        this.commonService = new ApiService().apiCommonService;
    },
    methods: {
		open() {
			this.display = true;
            try{
                this.commonService.getCompanies().then(response => {
                    if(response?.data?.success == true){
                        this.autoValue = response.data.data;
                    }
                });
            }
            catch(error){
                authStore.commit('setShowToast',['error','Error','Something went wrong please try again'])
            }
		},
		close() {
			this.display = false;
            this.selectedAutoValue = null
		},
        setDefaultCompany(isClear) {
			this.display = false;
            if(isClear){
                authStore.dispatch('setDefaultCompany',{});    
                this.defaultCompanyName = 'Not set';
                this.selectedAutoValue = null;
                authStore.commit('setShowToast',['success','Default Company Unset',''])
            }
            else{
                authStore.dispatch('setDefaultCompany',this.selectedAutoValue);
                this.defaultCompanyName = this.selectedAutoValue.name;
                authStore.commit('setShowToast',['success','Default Company Set','Default company set as '+this.selectedAutoValue.name])
            }
            
		},
        searchCompany(event) {
            setTimeout(() => {
                if (!event.query.trim().length) {
                    this.autoFilteredValue = [...this.autoValue];
                }
                else {
                    this.autoFilteredValue = this.autoValue.filter((company) => {
                        if (company && event && company.name && event.query) {
							return company.name.toLowerCase().startsWith(event.query.toLowerCase());
						}
                    });
                }
            }, 250);
        }
    }
}
</script>